import IScenario from '@/module/product/view/FulfillmentFormPage/model/contract/scenario/IScenario';

class EmptyScenario implements IScenario {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  run = (): void => {};
}

export default EmptyScenario;
